<template>
  <div>
    <PageHeader title="จัดการผู้สอน"></PageHeader>

    <b-container fluid="xl">
      <div class="py-5">
        <div class="inner bg-container">
          <div class="card card-csq no-shadow">
            <div class="card-header bg-light">
              <ul class="nav nav-tabs card-header-tabs float-left">
                <li class="nav-item">
                  <a class="nav-link active" href="#">รายบุคคล</a>
                </li>
              </ul>
            </div>
            <div class="card-body pt-4">
              <b-row class="align-items-start">
                <b-col sm="12" md="6" order-md="1">
                  <SearchBox
                    :title="`พิมพ์ชื่อผู้สอนที่ต้องการค้นหา`"
                    @typed="getSearchKeyword"
                    style="max-width: 420px"
                  />
                </b-col>
                <b-col sm="12" md="6" order-md="2" class="text-right mb-2">
                  <b-button
                    :to="{
                      name: 'instructor.create',
                      params: { company: company.url },
                    }"
                    variant="primary"
                  >
                    <b-icon-plus /> เพิ่มผู้สอน
                  </b-button>
                </b-col>
              </b-row>

              <b-table
                :items="items.data"
                :fields="fields"
                :busy="isLoading"
                :sort-by.sync="sort.by"
                :sort-desc.sync="sort.desc"
                sort-icon-left
                hover
                responsive
                class="mt-3 table-instructors"
              >
                <template v-slot:cell(displayName)="{ item }">
                  <router-link
                    :to="{
                      name: 'instructor.edit',
                      params: { id: item.id, company: company.url },
                    }"
                    class="text-csq"
                  >
                    <u>{{ item.displayName || "-" }}</u>
                  </router-link>
                </template>
                <template v-slot:cell(status)="{ item }">
                  {{ item.status === 1 ? "ใช้งาน" : "ไม่ใช้งาน" }}
                </template>
                <template v-slot:cell(action)="{ item }">
                  <!-- Placeholder action menu — actions to be defined later -->
                  <b-dropdown
                    variant="link"
                    toggle-class="text-decoration-none text-dark p-0"
                    no-caret
                    right
                  >
                    <template v-slot:button-content>
                      <b-icon icon="three-dots" scale="1.2"></b-icon>
                    </template>
                    <b-dropdown-item
                      :to="{
                        name: 'instructor.edit',
                        params: { id: item.id, company: company.url },
                      }"
                    >
                      <b-icon icon="pencil" scale="0.8" class="mr-2"></b-icon>
                      แก้ไขข้อมูล
                    </b-dropdown-item>
                    <b-dropdown-item @click="confirmRemove(item)">
                      <span class="d-flex align-items-center text-danger">
                        <b-icon
                          icon="trash"
                          scale="0.8"
                          class="mr-2"
                        ></b-icon>
                        ลบ
                      </span>
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
                <div slot="table-busy">
                  <b-spinner class="align-middle text-csq"></b-spinner>
                </div>
              </b-table>
            </div>
            <div class="card-footer bg-transparent border-0">
              <div class="row mt-3">
                <div class="col-lg-4">
                  <form class="form-inline">
                    <div class="form-group mb-2">
                      <label>แสดง</label>
                    </div>
                    <div class="form-group ml-2 mb-2">
                      <select
                        v-model="itemsLimit"
                        class="form-control form-control-sm border-0 bg-light"
                        @change="changeLimit($event)"
                      >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                      </select>
                    </div>
                    <div class="form-group ml-2 mb-2">
                      <label>
                        / {{ items.meta.total | formatNumber }} รายการ
                      </label>
                    </div>
                  </form>
                </div>
                <div class="col-lg-8">
                  <nav class="float-sm-right" aria-label="Page navigation">
                    <pagination
                      :data="items"
                      :limit="3"
                      class="pagination pagination-csq pagination-sm rounded-0"
                      @pagination-change-page="getResults"
                    >
                      <span slot="prev-nav">ก่อนหน้า</span>
                      <span slot="next-nav">ถัดไป</span>
                    </pagination>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /.inner -->
      </div>
    </b-container>
  </div>
</template>

<script>
import PageHeader from "../../layouts/PageHeader.vue";
import SearchBox from "../../shared/SearchBox";
import Pagination from "laravel-vue-pagination";
import Numeral from "numeral";
import api from "@/services/api";

export default {
  components: {
    SearchBox,
    Pagination,
    PageHeader,
  },

  filters: {
    formatNumber: function (value) {
      return Numeral(value).format("0,0");
    },
  },

  props: ["company"],

  data() {
    return {
      isLoading: true,
      items: {
        data: [],
        links: { first: null, last: null, prev: null, next: null },
        meta: {
          current_page: 0,
          from: 0,
          last_page: 0,
          path: null,
          per_page: 0,
          to: 0,
          total: 0,
        },
      },
      itemsLimit: 10,
      q: "",
      fields: [
        { label: "ชื่อผู้สอน", key: "displayName", sortable: true },
        { label: "ชื่อ - นามสกุล", key: "fullname", sortable: false },
        { label: "สถานะ", key: "status", sortable: true },
        { label: "", key: "action" },
      ],
      sort: {
        by: "displayName",
        desc: false,
      },
    };
  },

  computed: {
    sortOrder() {
      return this.sort.desc ? "desc" : "asc";
    },
  },

  watch: {
    sort: {
      async handler() {
        await this.getResults();
      },
      deep: true,
    },
  },

  created() {
    this.getResults();
  },

  methods: {
    async getResults(page = 1) {
      this.isLoading = true;
      await api
        .get(
          `/v1/instructors?page=${page}&limit=${this.itemsLimit}&q=${this.q}&sort_by=${this.sort.by}&sort_order=${this.sortOrder}`
        )
        .then(({ data }) => {
          this.items = data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    getSearchKeyword(value) {
      this.q = value;
      this.getResults();
    },

    changeLimit(event) {
      this.itemsLimit = event.target.value;
      this.getResults();
    },

    confirmRemove(item) {
      const name = item.displayName || item.fullname || "ผู้สอน";
      this.$bvModal
        .msgBoxConfirm(`ต้องการลบผู้สอน ${name} ใช่หรือไม่?`, {
          title: "ยืนยันการลบผู้สอน",
          size: "md",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "ลบผู้สอน",
          cancelTitle: "ยกเลิก",
          cancelVariant: "light",
          footerClass: "p-2",
          centered: true,
        })
        .then((confirm) => {
          if (confirm) this.removeInstructor(item);
        });
    },

    async removeInstructor(item) {
      const name = item.displayName || item.fullname || "ผู้สอน";
      try {
        const { data } = await api.delete(`/v1/instructors/${item.id}`);
        if (data.status === "success") {
          this.toast(`ลบผู้สอน ${name} เรียบร้อยแล้ว`, "สำเร็จ", "success");
          this.getResults();
        } else {
          this.toast(`ลบผู้สอน ${name} ไม่สำเร็จ`, "ไม่สำเร็จ", "danger");
        }
      } catch (err) {
        const message =
          (err.response && err.response.data && err.response.data.message) ||
          `ลบผู้สอน ${name} ไม่สำเร็จ`;
        this.toast(message, "ไม่สำเร็จ", "danger");
      }
    },

    toast(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
      });
    },
  },
};
</script>

<style scoped>
.table-instructors {
  overflow-x: unset !important;
}
</style>
